import {load} from '@shopify/theme-sections';
import '../sections/blog';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
